import { ReactNode } from 'react'
import styled from 'styled-components'

export const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(180deg, #f7f2fb 0%, #ffffff 100%);
`

export const Card = styled.div`
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;

  h1 {
    font-size: 22px;
    margin: 0 0 8px;
    color: #39383a;
  }
`

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    font-size: 12px;
    color: #6b6b6b;
  }

  span {
    font-size: 16px;
    color: #39383a;
  }
`

export const EventLink = styled.a<{
  children: ReactNode
  href?: string
  target?: string
  rel?: string
}>`
  color: #8601c9;
  margin-top: 4px;
  text-decoration: underline;
`

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`

export const ErrorText = styled.p`
  color: #c62828;
  font-size: 14px;
  margin: 8px 0 0;
`

export const SuccessText = styled.p`
  color: #2e7d32;
  font-size: 14px;
  margin: 8px 0 0;
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    margin: 0;
    text-align: center;
  }
`

export const Input = styled.input<{
  name?: string
  type?: string
  placeholder?: string
  value?: string
  onChange?: (e: any) => void
  onBlur?: (e: any) => void
}>`
  height: 52px;
  border-radius: 8px;
  border: 0;
  background: #f3f4f5;
  padding: 0 16px;
  font-size: 16px;

  &:focus {
    outline: none;
    border: 1px solid #8601c9;
    background: #ffffff;
  }
`
